export default __webpack_public_path__ + "static/media/ic_tags.5b5907fa.webp";